export const DEFAULT_BILL_TO_ADDRESS_ACCOUNTS_RECEIVABLE_ID = 'PROSPECT';
export const LISTBOX_STYLE = {
  maxHeight: {
    xs: '50vh',
    sm: '45vh',
    md: '40vh',
  },
};
